import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { compose } from "underscore";
import styles from "./styles";
import { withRouter } from "react-router-dom";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import { clearError, updateProfile, resetData } from "../redux/action";
import { ONBOARDING, DEEPLINK } from "../redux/constant";
import { withErrorBoundary } from "../../utils/functions/withErrorBoundary";

import {
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Icon,
  TextField,
  InputAdornment,
  Checkbox,
  Box,
} from "@mui/material";
import {
  StepLabel,
  CustomInput,
  Dropdown,
  CustomButton,
  ProfileDropdown,
  Alert,
  CountryItem,
  DefaultLoader,
  AlertInfo,
  Tooltip,
} from "../../components";
import {
  getOccupations,
  getNOBV2,
  getAnnualIncomeV2,
  getSourceOfFundV2,
  getCountryV2,
  getMaritalStatusV2,
  getInvestmentObjective,
} from "./redux/action";

import {
  resetTin,
  searchTin,
  searchTinSuccess,
} from "../profile/redux/actions.js";

import moment from "moment";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {
  findValue,
  findOccupation,
  manipulateCountry,
  knowTheGender,
  findIdentities,
  handleNotExist,
  checkEmptyArray,
  autoPopulateForm,
  validationFromStepOne,
} from "./utils.js";
import { NO, NRIC, TIN_MS_ERROR_MESSAGE, YES } from "../../utils/constants.js";
import LoadingInput from "../../components/LoadingInput/index.js";
const stopOccupations = ["23", "91", "90", "62"];
const occupationWhiteList = ["23", "62", "65", "90", "91"];
const searchByName = "name";
const searchByDescription = "description";
const employerNameFormat = /^[a-zA-Z. ]+$/;

const TextArea = props => (
  <textarea
    {...props}
    style={{
      fontSize: "16px",
      lineHeight: "1.4375em",
      padding: "16.5px 14px",
      minHeight: "88px", // mimics 4 rows
      resize: "vertical",
      border: "none",
      outline: "none",
      width: "100%",
      boxSizing: "border-box",
    }}
  />
);

function ProfileFormStepTwo(props) {
  const {
    history,
    onboardStepOne = {},
    getOccupations,
    occupationV2List = [],
    getOccupationsLoading,
    profile = {},
    getNOBLoading,
    natureOfBusinessV2List = [],
    getNOBV2,
    getAnnualIncomeV2,
    annualIncomeV2list = [],
    getAnnualIncomeV2Loading,
    getSourceOfFundV2,
    sourceOfFundListV2 = [],
    getSOFLoading,
    getCountryV2,
    getCountryV2Loading,
    countryListV2,
    getMaritalStatusV2,
    maritalStatusV2 = [],
    getMaritalStsLoading,
    getInvestmentObjective,
    investmentObjectiveLoading,
    investmentObjective = [],
    resetData,
    error,
    updateProfile,
    loading,
    location,
    resetTin,
    searchTin,
    searchingTin,
    searchTinSuccess,
    searchTinError,
    tin,
  } = props;
  const {
    idNo = "",
    race = {},
    email = "",
    mobileNo = "",
    address,
  } = onboardStepOne;

  const [profileInfo, setProfileInfo] = useState({});
  const [isBlank, setIsBlank] = useState(false);
  const [requireInfo, setRequireInfo] = useState({});
  const [PEPalert, setPEPalert] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [isChecked, setIsChecked] = useState(false);

  const [openDropdown, setOpenDropdown] = useState({
    occupation: false,
    business: false,
    annualIncome: false,
    sourceOfFund: false,
    taxtResident: false,
  });
  const [value, setValue] = useState({
    occupation: { name: "", code: "" },
    business: { name: "", code: "" },
    annualIncome: { name: "", code: "" },
    sourceOfFund: { name: "", code: "" },
    investmentObj: { name: "", code: "" },
    blockedNob: false,
    employerName: "",
    employerNameEdited: true,
    isPoliticalPosition: NO,
    otherTaxResident: NO,
    taxCountry: "",
    taxCountrySearch: "",
    selectedTaxCountry: { name: "", code: "" },
    taxIdNo: "",
    countryOfBirth: { name: "", code: "" },
    maritalSts: { name: "", code: "" },
  });

  const [{ isOptInForNotification, isVc }, setQuestion] = useState({
    isVc: profile?.isVc ? YES : NO,
    isOptInForNotification: profile?.optIn ? YES : NO,
  });

  const [{ vcDescription }, setTextAnswer] = useState({
    vcDescription: "",
  });
  const [formStatus, setFormStatus] = React.useState("idle");

  const isVcYesButVcDescriptionIsBlank = isVc === YES && vcDescription === "";
  // const isTINYesButTINIsBlank = isTINNumberExist === YES && tin === "";

  // const TINExceedMaxLength = tin.length > 20;
  // const TINLessThanMinLength = (tin.length < 10) & (tin.length > 0);

  const vcDescriptionExceedMaxLength = vcDescription.length > 100;
  const vcDescriptionLessThanMinLength = vcDescription.length < 3;
  const anchorRef = useRef(null);
  const optInRef = useRef(null);

  const [showInfo, setShowInfo] = useState(false);
  const [showOptInInfo, setShowOptInInfo] = useState(false);
  const handleOpenPDF = pdfUrl => {
    window.my.showLoading();
    window.my.postMessage({
      api: "downloadFile",
      pdf: pdfUrl,
      event: "openPdf",
    });
  };
  const handleError = (field, value) => {
    setFieldError(prevState => ({
      ...prevState,
      [field]: value,
    }));
  };

  const [fieldError, setFieldError] = useState({
    occupation: false,
    business: false,
    annualIncome: false,
    sourceOfFund: false,
    taxCountry: false,
    taxIdNo: false,
  });

  const {
    occupationTypeCd = "",
    natureOfBusinessCd = "",
    yearlyIncomeLevelCd = "",
    sourceOfFundCd = "",
    countryOfBirth = "",
    dob = "",
    fullName = "",
    gender = "",
    lang = "",
    maritalStatusCd = "",
    masterId = "",
    contacts = [],
    townOfBirth = "",
    identities = [],
    pepFlag = "",
  } = profileInfo;

  const identity = findIdentities(identities, idNo);
  const [isInitialized, setIsInitialized] = useState(false);

  const userNric =
    profile?.identities?.find(identity => identity.idTypeCd === NRIC)?.idNo ||
    "";

  useEffect(() => {
    let tempDataStepOne = onboardStepOne;
    if (!profile) {
      resetData();
      localStorage.removeItem("mpUserInfo");
      return history.push("/");
    }
    tempDataStepOne.masterId = profile.masterId;
    let checkStepOne = validationFromStepOne({
      ...onboardStepOne,
      state: onboardStepOne.address.state,
    });
    if (!checkStepOne) {
      resetData();
      localStorage.removeItem("mpUserInfo");
      return history.push("/");
    }
  }, [onboardStepOne]);

  useEffect(() => {
    if (
      typeof profile === "object" &&
      !Array.isArray(profile) &&
      profile !== null
    ) {
      setProfileInfo(profile);
    }
  }, [profile]);

  useEffect(() => {
    getOccupations();
    getNOBV2();
    getAnnualIncomeV2();
    getSourceOfFundV2();
    getMaritalStatusV2();
    getInvestmentObjective();
    if (!("Cypress" in window)) {
      getCountryV2();
    }
  }, []);

  const findCountry = e => {
    let filterCountry = countryListV2.filter(val =>
      val.name.toLowerCase().includes(e.toLowerCase())
    );

    setCountryList(filterCountry);
  };
  const handleSelectTaxCountry = val => {
    const { name, code } = val;
    let tempCountry = { name, code };
    let result = [...countryListV2];
    const index = result.findIndex(e => e.code === code);
    result.unshift(result.splice(index, 1)[0]);

    setCountryList(result);
    setValue({
      ...value,
      selectedTaxCountry: tempCountry,
      taxCountrySearch: "",
    });
    setOpenDropdown({ ...openDropdown, taxtResident: false });
    setFieldError({ ...fieldError, taxCountry: false });
  };

  const handleSelectOccupation = id => {
    let tempOccupation = { name: "", code: "" };
    let blockedNob = false;
    let employerNameEdited = true;
    let occupationItem = {};
    if (Array.isArray(occupationV2List)) {
      occupationItem = occupationV2List.find(item => item.code === id);
    }

    if (occupationItem) {
      tempOccupation = {
        name: occupationItem.name,
        code: occupationItem.code,
      };
    } else {
      setOpenDropdown({ ...openDropdown, occupation: false });

      return;
    }
    if (stopOccupations.includes(id)) {
      blockedNob = true;
    }
    if (occupationWhiteList.includes(id)) {
      employerNameEdited = false;
    }
    setValue({
      ...value,
      occupation: tempOccupation,
      blockedNob,
      employerNameEdited,
    });
    setOpenDropdown({ ...openDropdown, occupation: false });
    setFieldError({ ...fieldError, occupation: false, business: false });
  };

  const handleSelectBusinessNature = id => {
    let tempNob = { name: "", code: "" };
    let nobItem = {};

    if (Array.isArray(natureOfBusinessV2List)) {
      nobItem = natureOfBusinessV2List.find(item => item.code === id);
    }
    if (nobItem) {
      tempNob = { name: nobItem.name, code: nobItem.code };
    } else {
      setOpenDropdown({ ...openDropdown, business: false });

      return;
    }
    setValue({ ...value, business: tempNob });
    setOpenDropdown({ ...openDropdown, business: false });
    setFieldError({ ...fieldError, business: false });
  };

  const handleSelectAnnualIncome = id => {
    let tempAnnualIncome = { name: "", code: "" };
    let annualIncomeItem = {};
    if (Array.isArray(annualIncomeV2list)) {
      annualIncomeItem = annualIncomeV2list.find(item => item.code === id);
    }
    if (annualIncomeItem) {
      tempAnnualIncome = {
        name: annualIncomeItem.description,
        code: annualIncomeItem.code,
      };
    } else {
      setOpenDropdown({ ...openDropdown, annualIncome: false });

      return;
    }
    setValue({ ...value, annualIncome: tempAnnualIncome });
    setOpenDropdown({ ...openDropdown, annualIncome: false });
    setFieldError({ ...fieldError, annualIncome: false });
  };

  const handleSelectSOF = id => {
    let tempSOF = { name: "", code: "" };
    let SOFitem = {};
    if (Array.isArray(sourceOfFundListV2)) {
      SOFitem = sourceOfFundListV2.find(item => item.code === id);
    }
    if (SOFitem) {
      tempSOF = {
        name: SOFitem.description,
        code: SOFitem.code,
      };
    } else {
      setOpenDropdown({ ...openDropdown, sourceOfFund: false });

      return;
    }
    setValue({ ...value, sourceOfFund: tempSOF });
    setOpenDropdown({ ...openDropdown, sourceOfFund: false });
    setFieldError({ ...fieldError, sourceOfFund: false });
  };

  const handleChangeEmployer = value => {
    if (employerNameFormat.test(value) || value === "") {
      setValue(prev => ({ ...prev, employerName: value }));
    }
  };

  const handleChangePEP = val => {
    const { name, value } = val.target;

    setValue(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleToggleQuestion = ({ target }) => {
    setQuestion(prev => ({ ...prev, [target.name]: target.value }));
    setFormStatus("idle");
  };

  const handleTextAnswer = ({ target }) => {
    const filtered = target.value.replace(/[^a-zA-Z0-9.,!?:;'"()\-\n ]/g, "");
    setTextAnswer(prev => ({ ...prev, [target.name]: filtered }));
  };

  const handleChangeOtherTaxt = val => {
    const { name, value } = val.target;

    setValue(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    let checkCountryList = checkEmptyArray(countryListV2);
    let checkOccupationList = checkEmptyArray(occupationV2List);
    let checkNOBV2List = checkEmptyArray(natureOfBusinessV2List);
    let checkAnnualIncomelist = checkEmptyArray(annualIncomeV2list);
    let checksourceOfFundList = checkEmptyArray(sourceOfFundListV2);
    let checkMaritalStatusList = checkEmptyArray(maritalStatusV2);
    let tempPepFlag = NO;
    let lovResult = autoPopulateForm(
      checkCountryList,
      checkOccupationList,
      checkNOBV2List,
      checkAnnualIncomelist,
      checksourceOfFundList,
      checkMaritalStatusList
    );
    if (!lovResult) return;

    let tempCountry = manipulateCountry(countryListV2);
    let tempOccupation = findOccupation(
      occupationV2List,
      occupationTypeCd,
      searchByName
    );
    let tempNob = findValue(
      natureOfBusinessV2List,
      natureOfBusinessCd,
      searchByName
    );
    let tempAnnualIncome = findValue(
      annualIncomeV2list,
      yearlyIncomeLevelCd,
      searchByDescription
    );
    let tempSourceOfFund = findValue(
      sourceOfFundListV2,
      sourceOfFundCd,
      searchByDescription
    );
    let tempCountryBirth = findValue(
      countryListV2,
      countryOfBirth,
      searchByName
    );
    let tempMaritalSts = findValue(
      maritalStatusV2,
      maritalStatusCd,
      searchByName
    );

    if ("pepFlag" in profileInfo && pepFlag === "1") {
      tempPepFlag = YES;
    }

    setValue({
      ...value,
      annualIncome: tempAnnualIncome,
      occupation: { name: tempOccupation.name, code: tempOccupation.code },
      sourceOfFund: {
        name: tempSourceOfFund.name,
        code: tempSourceOfFund.code,
      },
      business: tempOccupation.blockedNob ? { name: "", code: "" } : tempNob,
      blockedNob: tempOccupation.blockedNob,
      employerNameEdited: tempOccupation.employerNameEdited,
      countryOfBirth: tempCountryBirth,
      maritalSts: tempMaritalSts,
      isPoliticalPosition: tempPepFlag,
    });
    setCountryList(tempCountry);
  }, [
    profileInfo,
    occupationV2List,
    natureOfBusinessV2List,
    annualIncomeV2list,
    sourceOfFundListV2,
    countryListV2,
  ]);

  const setIdentitiesPayload = () => {
    const currentIdentities = [
      {
        idTypeCd: identity.idTypeCd, //R
        idNo: identity.idNo,
        citizenship: identity.citizenship, //R
      },
    ];

    if (isOptInForNotification === YES && tin) {
      currentIdentities.push({
        idTypeCd: "TAX",
        idNo: tin,
        citizenship: "MY",
        taxType: "EInvoice",
      });
    }

    if (value.otherTaxResident.toLocaleLowerCase() === "yes") {
      currentIdentities.push({
        idTypeCd: "TAX",
        idNo: value.taxIdNo,
        citizenship: value.selectedTaxCountry.code,
        taxType: "CRS",
      });
    }

    return currentIdentities;
  };

  const requireValidation = val => {
    const tempError = {
      occupation: false,
      business: false,
      income: false,
      sourceOfFund: false,
      investmentObj: false,
      taxCountry: false,
      taxIdNo: false,
    };
    let requireField = {
      occupation: val.occupationTypeCd,
      business: val.natureOfBusinessCd,
      income: val.yearlyIncomeLevelCd,
      sourceOfFund: val.sourceOfFundCd,
      investmentObj: val.investmentObjCd,
    };

    if (isVc === YES) {
      tempError.vcDescription = false;
      requireField.vcDescription = vcDescription;
    }

    if (value.otherTaxResident.toLocaleLowerCase() === "yes") {
      requireField.taxCountry = val.identities[1].citizenship;
      requireField.taxIdNo = val.identities[1].idNo;
    }

    for (const key in requireField) {
      if (requireField[key].length === 0) {
        tempError[key] = true;
      }
    }
    if (value.otherTaxResident.toLocaleLowerCase() === "yes") {
      if (requireField.taxIdNo.length >= 20) {
        tempError.taxIdNo = true;
      }
    }
    setFieldError(prevState => ({
      ...prevState,
      occupation: tempError.occupation,
      business: tempError.business,
      annualIncome: tempError.income,
      sourceOfFund: tempError.sourceOfFund,
      taxCountry: tempError.taxCountry,
      taxIdNo: tempError.taxIdNo,
    }));
    let requireInfoTemp = {};
    if (tempError.occupation) {
      requireInfoTemp.occupation = "Occupation";
    }
    if (tempError.business) {
      requireInfoTemp.natureOfBusiness = "Nature of business";
    }

    if (tempError.income) {
      requireInfoTemp.annualIncome = "Annual Income";
    }

    if (tempError.sourceOfFund) {
      requireInfoTemp.sourceOfFund = "Source Of Funds";
    }

    if (tempError.investmentObj) {
      requireInfoTemp.purposeOfInvestment = "Purpose Of Invesment";
    }

    if (tempError.taxCountry) {
      requireInfoTemp.taxCountry = "Tax Country";
    }

    if (tempError.taxIdNo) {
      requireInfoTemp.taxIdNo = "Tax Id No";
    }

    if (isVcYesButVcDescriptionIsBlank) {
      requireInfoTemp.vcDescription = "Vulnerable Client Description";
    }

    setRequireInfo(requireInfoTemp);

    for (const key in tempError) {
      if (tempError[key] === true) {
        return false;
      }
    }

    return true;
  };

  const handleSubmit = () => {
    setFormStatus("submitting");

    if (value.isPoliticalPosition.toLocaleLowerCase() !== "no") {
      setPEPalert(true);
      return;
    }

    let payload = {
      natureOfBusinessCd: value.business.code,
      occupationTypeCd: value.occupation.code,
      yearlyIncomeLevelCd: value.annualIncome.code,
      sourceOfFundCd: value.sourceOfFund.code,
      investmentObjCd: value.investmentObj.code,
      identities: setIdentitiesPayload(),
      countryOfBirth: value.countryOfBirth.code,
      dob: dob ? moment(dob).format("YYYY-MM-DD") : "",
      employerName: value.employerName === "" ? "-" : value.employerName,
      fullName,
      gender: knowTheGender(gender),
      lang,
      maritalStatusCd: value.maritalSts.code,
      masterId,
      mobileNo,
      race: race.code,
      email,
      address: {
        ...address,
        state: address.state.code,
      },
      townOfBirth: handleNotExist(townOfBirth),
      isVc: isVc === YES,
      optIn: isOptInForNotification === YES && Boolean(tin),
    };

    if (payload.isVc) {
      payload.vcDescription = vcDescription;
    }

    if (value.blockedNob) {
      payload.natureOfBusinessCd = "99";
    }

    let validation = requireValidation(payload);
    if (!validation) {
      setIsBlank(true);
      return;
    }

    if (
      isVc === YES &&
      (vcDescriptionExceedMaxLength || vcDescriptionLessThanMinLength)
    )
      return;

    /* if (
      isOptInForNotification === YES &&
      (TINExceedMaxLength || TINLessThanMinLength)
    ) {
      tinRef?.current?.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        tinRef.current?.focus();
      }, 300);
      return;
    } */

    dataLayerGTM(
      "click_tag",
      "Click",
      "Button",
      `Click Onboarding Submit Step 2`
    );
    const resetForm = () => {
      setFormStatus("idle");
    };
    if (location.state) {
      const { type = "NOTSET", code = "NOTSET", plan } = location.state;

      updateProfile(
        {
          payloadData: payload,
          from: { from: DEEPLINK, value: { type, code, plan } },
        },
        resetForm
      );
    } else {
      updateProfile({ payloadData: payload, from: ONBOARDING }, resetForm);
    }

    /* const callback = err => {
      if (err?.errorCode === "ETN-00002") {
        setTinErrorMessage(
          "Validation with LHDN failed, please enter a valid TIN"
        );
        tinRef?.current?.scrollIntoView({ behavior: "smooth" });
        setTimeout(() => {
          tinRef.current?.focus();
        }, 300);
        return;
      }

      if (err) return;

      if (location.state) {
        const { type = "NOTSET", code = "NOTSET", plan } = location.state;

        updateProfile(
          {
            payloadData: payload,
            from: { from: DEEPLINK, value: { type, code, plan } },
          },
          resetForm
        );
      } else {
        updateProfile({ payloadData: payload, from: ONBOARDING }, resetForm);
      }
    }; */

    /* if (isTINNumberExist === YES && tin) {
      validateTin({
        payload: {
          idType: identity?.idTypeCd,
          idValue: identity?.idNo,
          tin: tin,
        },
        callback,
      });
    } else {
      callback();
    } */
  };

  // Initialize component state first
  useEffect(() => {
    const profileTin =
      profile?.identities?.find(
        identity =>
          identity.idTypeCd === "TAX" && identity.taxType === "EInvoice"
      )?.idNo || "";
    if (profileTin) {
      searchTinSuccess(profileTin);
    } else {
      resetTin();
    }

    setIsInitialized(true);
  }, [profile, resetTin, searchTinSuccess]);

  // Only trigger searchTin after initialization and when user opts in
  useEffect(() => {
    if (
      isInitialized &&
      isOptInForNotification === YES &&
      !searchingTin &&
      !tin &&
      !searchTinError &&
      userNric
    ) {
      searchTin({
        idType: NRIC,
        idNo: userNric,
      });
    }
  }, [
    isOptInForNotification,
    searchingTin,
    tin,
    userNric,
    isInitialized,
    searchTin,
    searchTinError,
  ]);

  if (
    getOccupationsLoading ||
    getNOBLoading ||
    getAnnualIncomeV2Loading ||
    getSOFLoading ||
    getCountryV2Loading ||
    getMaritalStsLoading ||
    investmentObjectiveLoading ||
    loading
  ) {
    return <DefaultLoader />;
  }

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <Alert
        title="Please fill in required fields"
        isObject={requireInfo}
        isOpen={isBlank}
        isCancel={false}
        handleAction={() => setIsBlank(false)}
      />
      <Alert
        title="Account doesn’t meet requirement"
        description="So sorry, your account doesn’t meet our requirement."
        isOpen={PEPalert}
        isCS="https://principal.com.my"
        isCancel={false}
        handleAction={() => {
          resetData();
          history.push("/");
          setPEPalert(false);
        }}
      />
      <AlertInfo
        description="We are facing some technical issues, and we are working very hard to resolve the issue."
        isOpen={error === "timeoutError"}
        isTimeout={true}
        handleAction={() => {
          clearError();
          resetData();
          history.push("/");
        }}
      />
      <StepLabel
        title="Profile info"
        containerStyles={{ padding: "16px 16px 22px" }}
        onClick={() => {
          history.push("/onBoarding/form-step-one");
        }}
      />

      <Box sx={{ margin: "0px 16px 4px 16px" }}>
        <Typography
          color="secondary"
          sx={{ fontSize: "14px", fontWeight: "700" }}
        >
          Step 2 of 2
        </Typography>
      </Box>
      <Box sx={{ margin: "0 16px 16px" }}>
        <Typography color="secondary" sx={{ fontWeight: "700" }}>
          Employment information
        </Typography>
      </Box>
      <Box sx={{ margin: "0 16px" }}>
        <CustomInput
          label="Occupation"
          name="occupation"
          value={value.occupation.name}
          isEdit={true}
          isRequired={true}
          isDropdown={true}
          onClick={() => setOpenDropdown({ ...openDropdown, occupation: true })}
          error={fieldError.occupation}
          helperText={"This field is required"}
        />
        <Dropdown
          bottomHeight={({ maxHeight }) => maxHeight - maxHeight / 10}
          isOpen={openDropdown.occupation}
          handleDismiss={() =>
            setOpenDropdown({ ...openDropdown, occupation: false })
          }
        >
          <ProfileDropdown
            title="Occupation"
            itemList={occupationV2List}
            selectedItem={value.occupation.code}
            handleClick={handleSelectOccupation}
          />
        </Dropdown>
        <CustomInput
          label="Nature of business"
          name="business"
          value={value.blockedNob ? "Not Applicable" : value.business.name}
          isEdit={!value.blockedNob}
          isRequired={true}
          isDropdown={true}
          helperText={"This field is required"}
          onClick={() => {
            setOpenDropdown({ ...openDropdown, business: !value.blockedNob });
          }}
          error={fieldError.business}
        />
        <Dropdown
          bottomHeight={({ maxHeight }) => maxHeight - maxHeight / 10}
          isOpen={openDropdown.business}
          handleDismiss={() =>
            setOpenDropdown({ ...openDropdown, business: false })
          }
        >
          <ProfileDropdown
            title="Business nature"
            itemList={
              !Array.isArray(natureOfBusinessV2List) ||
              natureOfBusinessV2List === null ||
              !natureOfBusinessV2List
                ? []
                : natureOfBusinessV2List.filter(item => item.code !== "99")
            }
            selectedItem={value.blockedNob ? "99" : value.business.code}
            handleClick={handleSelectBusinessNature}
          />
        </Dropdown>
        <CustomInput
          label="Annual income"
          name="income"
          value={value.annualIncome.name}
          isEdit={true}
          isRequired={true}
          isDropdown={true}
          helperText={"This field is required"}
          onClick={() =>
            setOpenDropdown({ ...openDropdown, annualIncome: true })
          }
          error={fieldError.annualIncome}
        />
        <Dropdown
          bottomHeight={({ maxHeight }) => maxHeight * 0.6}
          isOpen={openDropdown.annualIncome}
          handleDismiss={() =>
            setOpenDropdown({ ...openDropdown, annualIncome: false })
          }
        >
          <ProfileDropdown
            title="Annual income"
            itemList={annualIncomeV2list}
            selectedItem={value.annualIncome.code}
            handleClick={handleSelectAnnualIncome}
          />
        </Dropdown>
        <CustomInput
          label="Employer name"
          name="employerName"
          value={value.employerName}
          onChange={e => {
            handleChangeEmployer(e.target.value);
          }}
          isEdit={value.employerNameEdited}
          isRequired={false}
        />
      </Box>
      <Box sx={{ margin: "0 16px 16px", marginTop: "38px" }}>
        <Typography color="secondary" sx={{ fontWeight: "700" }}>
          Other information
        </Typography>
      </Box>

      <Box sx={{ margin: "0 16px" }}>
        <CustomInput
          label="Source of Funds"
          name="sourceOfFund"
          value={value.sourceOfFund.name}
          isEdit={true}
          isRequired={true}
          isDropdown={true}
          helperText={"This field is required"}
          onClick={() =>
            setOpenDropdown({ ...openDropdown, sourceOfFund: true })
          }
          error={fieldError.sourceOfFund}
        />
        <Dropdown
          bottomHeight={({ maxHeight }) => maxHeight * 0.6}
          isOpen={openDropdown.sourceOfFund}
          handleDismiss={() =>
            setOpenDropdown({ ...openDropdown, sourceOfFund: false })
          }
        >
          <ProfileDropdown
            title="Source Of Funds"
            itemList={sourceOfFundListV2}
            selectedItem={value.sourceOfFund.code}
            handleClick={handleSelectSOF}
          />
        </Dropdown>
        <Typography
          color="textPrimary"
          sx={{
            fontWeight: "700",
            fontSize: "14px",
            lineHeight: 1.57,
            marginBottom: "8px",
            marginTop: "14px",
          }}
        >
          What is the purpose of your investment?*
        </Typography>
        <FormControl>
          <RadioGroup
            sx={{ marginBottom: "14px" }}
            name="cashPurpose"
            value={value.investmentObj.code}
            onChange={e =>
              setValue({
                ...value,
                investmentObj: { name: "", code: e.target.value },
              })
            }
          >
            {investmentObjective
              .sort((a, b) => a.code - b.code)
              .map(({ code, name }) => (
                <FormControlLabel
                  key={code}
                  value={code}
                  control={
                    <Radio
                      color="primary"
                      inputProps={{ "data-cy": `purpose-${code}` }}
                    />
                  }
                  label={<Typography>{name}</Typography>}
                />
              ))}
          </RadioGroup>
        </FormControl>
        <CustomInput
          label="Do you hold a position (or related to such persons) in any Public or Political offices, Including being its committee or council member"
          name="isPoliticalPosition"
          value={value.isPoliticalPosition}
          onChange={handleChangePEP}
          isEdit={true}
          isRequired={false}
          isRadio={true}
        />
        <CustomInput
          label="Opt in for e-invoice notification"
          name="isOptInForNotification"
          value={isOptInForNotification}
          onChange={handleToggleQuestion}
          isEdit={true}
          isRadio={true}
        />
        {isOptInForNotification === YES && (
          <>
            <Typography
              color="textPrimary"
              sx={{
                fontWeight: "700",
                fontSize: "14px",
                lineHeight: 1.57,
                marginBottom: "8px",
              }}
            >
              Your Tax Identification Number (TIN) retrieved from the LHDN
              website
            </Typography>
            <LoadingInput
              placeholder={
                searchingTin
                  ? "Retrieving TIN"
                  : searchTinError
                  ? "TIN retrieval failed"
                  : ""
              }
              value={tin}
              disabled
              loading={searchingTin}
              helperText={searchTinError ? TIN_MS_ERROR_MESSAGE : ""}
              error={searchTinError}
            />
          </>
        )}

        <CustomInput
          label={
            <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span>Are you a vulnerable client?</span>
              <Tooltip
                copywriting="Someone needing extra support due to disability, major life events, low financial knowledge, or low tech confidence"
                isActive={showInfo}
                callback={e => {
                  const target = e.target;
                  if (target.classList.contains("tooltip-text")) return;
                  setShowInfo(false);
                }}
                tooltipRef={anchorRef}
                anchor={
                  <svg
                    width={22}
                    height={22}
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    ref={anchorRef}
                    style={{
                      position: "relative",
                      top: "4px",
                    }}
                    onClick={() => {
                      setShowInfo(prev => !prev);
                    }}
                  >
                    <path
                      d="M9.99993 9.16658C10.4602 9.16658 10.8333 9.53968 10.8333 9.99991V13.3332C10.8333 13.7935 10.4602 14.1666 9.99993 14.1666C9.53969 14.1666 9.1666 13.7935 9.1666 13.3332V9.99991C9.1666 9.53968 9.53969 9.16658 9.99993 9.16658Z"
                      fill="#0061A0"
                    />
                    <path
                      d="M9.99993 5.83325C9.53969 5.83325 9.1666 6.20635 9.1666 6.66659C9.1666 7.12682 9.53969 7.49992 9.99993 7.49992H10.0083C10.4685 7.49992 10.8416 7.12682 10.8416 6.66659C10.8416 6.20635 10.4685 5.83325 10.0083 5.83325H9.99993Z"
                      fill="#0061A0"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.833252 9.99992C0.833252 4.93731 4.93731 0.833252 9.99992 0.833252C15.0625 0.833252 19.1666 4.93731 19.1666 9.99992C19.1666 15.0625 15.0625 19.1666 9.99992 19.1666C4.93731 19.1666 0.833252 15.0625 0.833252 9.99992ZM9.99992 2.49992C5.85778 2.49992 2.49992 5.85778 2.49992 9.99992C2.49992 14.1421 5.85778 17.4999 9.99992 17.4999C14.1421 17.4999 17.4999 14.1421 17.4999 9.99992C17.4999 5.85778 14.1421 2.49992 9.99992 2.49992Z"
                      fill="#0061A0"
                    />
                  </svg>
                }
              />
            </span>
          }
          name="isVc"
          value={isVc}
          onChange={handleToggleQuestion}
          isEdit={true}
          isRequired={false}
          isRadio={true}
        />
        {isVc === YES && (
          <>
            <Typography
              color="textPrimary"
              style={{
                fontWeight: "700",
                fontSize: "14px",
                lineHeight: 1.57,
                marginBottom: "8px",
              }}
            >
              Description
            </Typography>
            <TextField
              name="vcDescription"
              type="text"
              variant="outlined"
              placeholder="Add short description to explain your vulnerability here"
              onChange={handleTextAnswer}
              value={vcDescription}
              error={
                formStatus === "submitting" &&
                (isVcYesButVcDescriptionIsBlank ||
                  vcDescriptionExceedMaxLength ||
                  vcDescriptionLessThanMinLength)
              }
              helperText={
                formStatus === "submitting" &&
                (isVcYesButVcDescriptionIsBlank
                  ? "This field is required"
                  : vcDescriptionLessThanMinLength
                  ? "Minimum 3 characters"
                  : vcDescriptionExceedMaxLength && "Maximum 100 characters")
              }
              InputProps={{
                inputComponent: TextArea,
              }}
              inputProps={{
                style: {
                  fontFamily: "FSElliotPro",
                },
              }}
              fullWidth
              style={{ marginBottom: "14px" }}
            />
          </>
        )}
        <CustomInput
          label="Are you a tax resident of any country other than Malaysia?"
          name="otherTaxResident"
          value={value.otherTaxResident}
          onChange={handleChangeOtherTaxt}
          isEdit={true}
          isRequired={false}
          isRadio={true}
        />
        {value.otherTaxResident.toLocaleLowerCase() === "yes" && (
          <>
            <CustomInput
              label="Tax Country"
              name="taxCountry"
              placeholder="Please select a country"
              value={value.selectedTaxCountry.name}
              onClick={() =>
                setOpenDropdown({ ...openDropdown, taxtResident: true })
              }
              isEdit={true}
              isRequired={true}
              isDropdown={true}
              error={fieldError.taxCountry}
            />

            <Dropdown
              bottomHeight={({ maxHeight }) => maxHeight - maxHeight / 10}
              isOpen={openDropdown.taxtResident}
              handleDismiss={() =>
                setOpenDropdown({ ...openDropdown, taxtResident: false })
              }
            >
              <div style={{ margin: "16px 16px 24px" }}>
                <Typography
                  color="secondary"
                  style={{ ...styles.baseFont, ...styles.dropdownTitle }}
                >
                  Update country
                </Typography>
                {/* Search */}
                <div style={{ marginTop: "16px" }}>
                  <TextField
                    placeholder="Type country name here"
                    variant="outlined"
                    fullWidth
                    value={value.taxCountrySearch}
                    onChange={e => {
                      setValue({
                        ...value,
                        taxCountrySearch: e.target.value,
                      });
                      findCountry(e.target.value);
                    }}
                    inputProps={{
                      style: {
                        ...styles.baseFont,
                        padding: "12px 16px",
                        color: "#333",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <SearchOutlinedIcon
                            sx={{
                              cursor: "pointer",
                              color: "#0091DA",
                              fontSize: 24,
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                {/* Country List */}
                <div style={{ marginTop: "24px" }}>
                  {countryList
                    ?.filter(item => item?.code !== "MY")
                    ?.map((item, index) => {
                      return (
                        <CountryItem
                          key={index}
                          country={item.name}
                          isSelected={
                            value.selectedTaxCountry.code === item.code
                          }
                          onClick={() => handleSelectTaxCountry(item)}
                          containerStyles={
                            value.selectedTaxCountry.code &&
                            index === 0 && {
                              borderBottom: "1px solid #C4C6C5",
                              paddingBottom: "24px",
                            }
                          }
                        />
                      );
                    })}
                </div>
              </div>
            </Dropdown>

            <CustomInput
              label="Tax ID Number"
              name="taxIdNo"
              value={value.taxIdNo}
              onChange={e => setValue({ ...value, taxIdNo: e.target.value })}
              handleBlur={() => {
                handleError(
                  "taxIdNo",
                  value.taxIdNo.length <= 20 ? false : true
                );
              }}
              isEdit={true}
              isRequired={true}
              error={fieldError.taxIdNo}
              helperText={
                value.taxIdNo.length >= 20
                  ? "Maximum length for tax id number is 20"
                  : "This field is required"
              }
            />
          </>
        )}
      </Box>
      <Box sx={{ margin: "24px 16px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            margin: "24px 0",
          }}
        >
          <Checkbox
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
            color="primary"
            sx={{
              margin: 0,
              padding: "0px !important",
              paddingTop: 0.5,
              "& .MuiSvgIcon-root": { fontSize: 24 },
            }}
            inputProps={{
              "data-cy": "onboard-terms-and-conditions",
            }}
          />
          <Box sx={{ marginLeft: "10px" }}>
            <Typography
              sx={{
                fontFamily: "FSElliotPro",
                fontSize: "14px",
                fontWeight: "normal",
                lineHeight: 1.29,
                color: "#787878",
                marginBottom: "8px",
              }}
            >
              I have read and agreed to{" "}
              <span
                style={{ color: "#0076cf" }}
                onClick={() =>
                  handleOpenPDF(
                    "https://www.principal.com.my/sites/default/files/pdf-uploads/Principal%20Mini%20Program%20%28IMMF%20Class%20D%29%20Terms%20and%20Conditions.pdf"
                  )
                }
              >
                Principal's Terms & Conditions
              </span>{" "}
              and{" "}
              <span
                style={{ color: "#0076cf" }}
                onClick={() =>
                  window.my.navigateTo({
                    url:
                      "/pages/link/link?url=" +
                      encodeURIComponent(
                        "https://www.principal.com.my/en/privacy-notice-my/mv"
                      ),
                  })
                }
              >
                Privacy Notice
              </span>
            </Typography>
            <Typography
              color="secondary"
              sx={{
                fontSize: "14px",
                lineHeight: 1.57,
                color: "#505050",
              }}
            >
              For any information that cannot be edited within the app, kindly
              contact our Customer Care Centre for assistance.
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          marginTop: "auto",
          padding: "16px",
          position: "sticky",
          bottom: 0,
          width: "100%",
          backgroundColor: "#fff",
        }}
      >
        <CustomButton
          text="Next"
          variant="contained"
          color="#fff"
          backgroundColor="#1278CC"
          disabled={!isChecked || searchingTin ? true : false}
          onClick={handleSubmit}
        />
      </Box>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    ...state.onBoardingReducer,
    profile: state.goal.profile,
    loading: state.goal.loading,
    error: state.goal.error,
    tin: state.profileReducer.tin,
    searchTin: state.profileReducer.searchTin,
    searchingTin: state.profileReducer.searchingTin,
    searchTinError: state.profileReducer.searchTinError,
  };
};
const mapDispatchToProps = dispatch => ({
  getNOBV2: () => dispatch(getNOBV2()),
  getOccupations: () => dispatch(getOccupations()),
  getAnnualIncomeV2: () => dispatch(getAnnualIncomeV2()),
  getCountryV2: () => dispatch(getCountryV2()),
  getSourceOfFundV2: () => dispatch(getSourceOfFundV2()),
  getMaritalStatusV2: () => dispatch(getMaritalStatusV2()),
  getInvestmentObjective: () => dispatch(getInvestmentObjective()),
  updateProfile: data => dispatch(updateProfile(data)),
  resetData: () => dispatch(resetData()),
  resetTin: () => dispatch(resetTin()),
  searchTin: payload => dispatch(searchTin(payload)),
  searchTinSuccess: payload => dispatch(searchTinSuccess(payload)),
});
const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
export default compose(
  withErrorBoundary,
  withRouter,
  withConnect
)(ProfileFormStepTwo);
